export default __webpack_public_path__ + "static/media/ezdoc_logo_white.cf7e6502.png";